import { render } from "./ProviderConfig.vue?vue&type=template&id=65a83c36"
import script from "./ProviderConfig.vue?vue&type=script&lang=js"
export * from "./ProviderConfig.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3011205126/src/emulator.totogidemos.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__